import { render, staticRenderFns } from "./ToolPageSurvey.vue?vue&type=template&id=cded231e&scoped=true&"
import script from "./ToolPageSurvey.vue?vue&type=script&lang=ts&"
export * from "./ToolPageSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPageSurvey.vue?vue&type=style&index=0&id=cded231e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cded231e",
  null
  
)

export default component.exports